import { Claim } from './../model/claim';
import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Dialog, DialogModule } from 'primeng/dialog';
import { ComponentBase } from '../../../../common/component-base';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MultiSelect, MultiSelectModule } from 'primeng/multiselect';
import { NgClass } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { ModuleService } from '../module.service';
import { NotificationService } from '../../../../common/service/notification.service';
import { ToggleSwitch } from 'primeng/toggleswitch';

@Component({
  selector: 'gate-add-module',
  standalone: true,
  imports: [
    Dialog,
    TranslatePipe,
    MultiSelect,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    InputTextModule,
    MultiSelectModule,
    ButtonModule,
    NgClass,
    ToggleSwitch,
    CheckboxModule,
    IconFieldModule,
    InputIconModule
  ],
  templateUrl: './add-module.component.html',
  styleUrl: './add-module.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddModuleComponent extends ComponentBase {
 public isVisible=false;
 public moduleForm!: FormGroup;
 @Input() public claims = signal<Claim[]>([]);

  constructor(private fb: FormBuilder, private moduleService: ModuleService, private notificationService: NotificationService) {
    super();
    this.initForm();
  }

public openDialog(): void {
  this.isVisible=true;
}

  initForm() {
    this.moduleForm = this.fb.group({
      name: ['', Validators.required],
      abbreviation: ['', Validators.required],
      claims: [[], Validators.required],
      isDefault: [false],
      isPublic: [false]
    });
  }

  get f() {
    return this.moduleForm.controls;
  }
  resetForm() {
    this.moduleForm.reset({
      name: '',
      abbreviation: '',
      claims: [],
      isDefault: false,
      isPublic: false
    });
  }

  public  onSubmit() {
 if (this.moduleForm.invalid) {
      this.moduleForm.markAllAsTouched();
      return;
    }
      this.SetLoading(true);
      const newModule: any = {
        moduleId: 0,
        name: this.moduleForm.value.name,
        abbreviation: this.moduleForm.value.abbreviation,
        isDefault: this.moduleForm.value.isDefault,
        isPublic: this.moduleForm.value.isPublic,
        roleIds: this.moduleForm.value.claims.map((claim: Claim) => claim.roleId)
      }; // Id handled by backend
      this.moduleService.addModule(newModule)
        .then((createdModule) => {
          createdModule.abbreviation ??= newModule.abbreviation;
          this.moduleService.newModuleAdded.emit(createdModule);
          this.isVisible=false;
          this.resetForm();
          this.notificationService.showNotification('success', 'notification.moduleManagement.add.success.title', 'notification.moduleManagement.add.success.message');
        })
        .catch((error) => {
          if (error == 'DUPLICATE_MODULE') {
            this.notificationService.showNotification('warn', 'notification.moduleManagement.duplicate.error.title', 'notification.moduleManagement.duplicate.error.message');
          } else {
            this.notificationService.showNotification('error', 'notification.moduleManagement.error.title', 'notification.moduleManagement.error.message');
          }
        })
        .finally(() => this.SetLoading(false));
    }
}
